<template>
	<div class="pages">
		<div class="serch-form">
			<el-form label-position="left" label-width="70px" :model="serchForm">
				<el-form-item label="申请人">
					<el-select size="small" style="width: 100%;" v-model="serchForm.name" :remote-method="remote" filterable remote clearable placeholder="请输入姓名进行搜索">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="申请日期">
					<el-input size="small" v-model="serchForm.time" type="date"></el-input>
				</el-form-item>
				<div style="text-align: center;padding-top: 6px;">
				    <el-button size="mini" type="primary" style="margin-right: 20px;" @click="query()">查询</el-button>
				    <el-button size="mini" style="margin-left: 20px;" @click='reset()'>重置</el-button>
				</div>
			</el-form>
		</div>
		<div class="pricing-list">
			<div class="totle">共计<span>{{pricingList.length}}</span>条</div>
			<div class="pricing-item" v-for="(item,index) in pricingList" :key="index" @click="click(item.Url)">
				<div class="title">{{item.FlowName}}</div>
				<div class="applicant-time clearfix">
					<div class="applicant">申请人：{{item.ApplicantName}}</div>
					<div class="time">{{item.CreateTime}}</div>
				</div>
				<div class="label" :class="item.Status == 100?'waiting-pricing':item.Status == 200?'waiting-check':''">{{item.Status == 100?'待核价':item.Status == 200?'待验收':'待审批'}}</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	
	import {
		GetPendingProcessList
	} from '@/api/approval'
	
	import {
		formatDate
	} from '@/utils/date.js'
	
	
	export default {
		data() {
			return {
				logInfo:{},
				serchForm: {},
				options: [],
				pricingList:[],
				names:{},
				datas:[]
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.load();
		},
		mounted() {
			
		},
		methods: {
			load(){
				var that = this;
				GetPendingProcessList(this.logInfo.EmpNo).then(response =>{
					console.log(response)
					that.pricingList = response.Body;
					that.datas = response.Body;
					that.pricingList.forEach(e=>{
						let name = that.names[e.ApplicantName]
						if(name==null||name==''){
							that.names[e.ApplicantName] = e.ApplicantName;
						}
					})
				})
			},
			click(url){
				this.$router.push(url);
			},
			remote(value){
				if(value==null||value.trim()==''){
					this.options = [];
				}else{
					var array = [];
					array = Object.keys(this.names).map(val => ({
					        key: val,
					        val: this.names[val]
					    }))
					var option = [];
					array.forEach(e =>{
						if(e.key.indexOf(value)>-1){
							option.push({label:e.key,value:e.key})
						}
					})
					this.options = option;
				}
			},
			query(){
				console.log(this.serchForm)
				var datas = this.datas;
				if(this.serchForm.name!=null&&this.serchForm.name.trim()!=''){
					let data = [];
					var name = this.serchForm.name;
					datas.forEach(e=>{
						if(e.ApplicantName == name){
							data.push(e);
						}
					})
					datas = data;
				}
				if(this.serchForm.time!=null&&this.serchForm.time!=''){
					let data = [];
					var time = this.serchForm.time;
					datas.forEach(e=>{
						if(e.CreateDate == time){
							data.push(e);
						}
					})
					datas = data;
				}
				this.pricingList = datas;
			},
			reset(){
				this.serchForm.time = '';
				this.serchForm.name = '';
				this.pricingList = this.datas;
			},
			renderTime(date) {
			  // var dateee = new Date(date).toJSON();
			  return formatDate(date,"yyyy-MM-dd HH:mm:ss")
			}
		}
	}
</script>

<style lang="less">
	
	.serch-form {
		background: #fff;
		padding: 10px;
		position: fixed;
		left: 0;
		top: 0;
		opacity: 1;
		z-index: 6;
		width: 100%;

		.el-form-item {
			margin-bottom: 0px;
		}
	}
	.pricing-list{
		padding: 10px;
		margin-top: 134px;
		.totle{
			font-size: 12px;
			// margin-top: 10px;
			span{
				color: #FF4346;
				padding: 0 4px;
			}
		}
		.pricing-item{
			width: 100%;
			background: #FFFFFF;
			position: relative;
			padding: 8px;
			margin-top: 10px;
			border-radius: 6px;
			box-shadow: 6px 6px 6px #CCCCCC;
			.title{
				font-size: 13px;
				color: #585354;
				line-height: 1.8;
				width: calc(100% - 40px);
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				padding-bottom: 4px;
			}
			.applicant-time{
				color: #585354;
				font-size: 12px;
				line-height: 1.7;
				div.applicant{
					width: 60%;
					float: left;
				}
				div.time{
					width: 40%;
					float: right;
					text-align: right;
				}
			}
			.label{
				position: absolute;
				right: 5px;
				top: 10px;
			}
			.waiting-pricing{
				color: #3FC243;
			}
			.waiting-check{
				color: #55ACEE;
			}
		}
		.pricing-item:first-child{
			margin-top: 0;
		}
	}
</style>
